import component from './PopularDestination';

export default component;
